module.exports = __webpack_public_path__ + "assets/img/idfa_notice.5d0cf36.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/idfa_notice.png
// module id = bSdx
// module chunks = 50